import styles from '../Main.module.css';
export default function Slider({info}) {
    return (
        <div className={styles['slides-wrapper']}>
            <img width="322" height="691" src={info.image} />																
            <div className={styles['unxw-vs-item-info']}>
                <span className={styles['unxw-vs-item-slide-text']} dangerouslySetInnerHTML={{ __html: info.title }} />
                <span className={styles['unxw-vs-item-title-image']}>
                    <img width="49" height="49" src={info.icon}  alt={info.title} />
                </span>
                <span className={styles['unxw-vs-item-title']} >{info.subtitle}</span>
                <span className={styles['unxw-vs-item-subtitle']}>{info.text}</span>
           </div>
        </div>
    );
}